<cm-card class="card">
    <cm-page-header class="page-header" text="Organization Custom Fields" [hideBackUrl]="true">
        <div>
            <button class="btn btn-default" *ngIf="policyPermissions.addField" (click)="onAddField()">
                + ADD FIELD
            </button>
            <button class="btn btn-default" *ngIf="policyPermissions.addFieldGroup" (click)="onAddGroup()">
                + ADD GROUP
            </button>
        </div>
    </cm-page-header>
    <div class="fields-container">
        <div class="fields-headers">
            <span class="fields-header fields-header--name">Name</span>
            <span class="fields-header fields-header--available-in-profile">Available in profile</span>
            <span class="fields-header fields-header--mapped">Mapped</span>
            <span class="fields-header fields-header--type">Type</span>
            <span class="fields-header fields-header--default-value">Default value</span>
            <span class="fields-header fields-header--status">Status</span>
        </div>
        <div
            class="ngx-dnd-container ngx-dnd-container__main auto-scroll-container"
            cmDndAutoScroll
            ngxDroppable="drop-main"
            [model]="fields"
            (drop)="onDrop($event, null)"
        >
            <ng-container *ngFor="let item of fields; trackBy: trackCustomFieldByFn">
                <cm-template-custom-field
                    *ngIf="!item.fields"
                    [moves]="policyPermissions.editField"
                    class="ngx-dnd-item"
                    [ngClass]="{ 'move-disabled': !policyPermissions.editField }"
                    [ngxDraggable]="['drop-main', 'drop-group']"
                    [model]="item"
                    [field]="item"
                    (onDelete)="onDeleteField(item)"
                    (onEdit)="onEditField(item)"
                    [policyPermissions]="policyPermissions"
                >
                </cm-template-custom-field>

                <cm-template-custom-group
                    *ngIf="item.fields"
                    [moves]="!!item.fields.length && policyPermissions.editField"
                    class="ngx-dnd-item"
                    [ngClass]="{ 'move-disabled': !item.fields.length || !policyPermissions.editField }"
                    [ngxDraggable]="['drop-main']"
                    [model]="item"
                    [group]="item"
                    (edit)="onAddGroup($event)"
                    (addFieldToGroup)="onAddField(item.group_id)"
                    (remove)="onDeleteGroup(item)"
                    [policyPermissions]="policyPermissions"
                >
                    <div
                        class="ngx-dnd-container ngx-dnd-container__group"
                        ngxDroppable="drop-group"
                        (drop)="onDrop($event, item.group_id)"
                        [model]="item.fields"
                    >
                        <p
                            *ngIf="!item.fields.length"
                            class="ngx-dnd-container__placeholder"
                            [ngxDraggable]="['drop-main']"
                            [moves]="false"
                        >
                            Group is empty
                        </p>

                        <cm-template-custom-field
                            *ngFor="let child of item.fields; trackBy: trackCustomFieldByFn"
                            class="ngx-dnd-item in-group"
                            [moves]="policyPermissions.editField"
                            [ngClass]="{ 'move-disabled': !policyPermissions.editField }"
                            [ngxDraggable]="['drop-main', 'drop-group']"
                            [model]="child"
                            [field]="child"
                            (onDelete)="onDeleteField(child)"
                            (onEdit)="onEditField(child)"
                            [policyPermissions]="policyPermissions"
                        >
                        </cm-template-custom-field>
                    </div>
                </cm-template-custom-group>
            </ng-container>
        </div>
    </div>
</cm-card>
<cm-custom-field-modal></cm-custom-field-modal>
<cm-custom-group-modal></cm-custom-group-modal>
<cm-template-group-undeletable-modal></cm-template-group-undeletable-modal>
